import { createSlice } from "@reduxjs/toolkit"
import { toast } from "react-toastify"

const languageSession = 'es'

const emailsStopped = false

const emptyUser = {
    id: '',
    name: '',
    surname: '',
    role: '',
    userMangoId: '',
    walletId: '',
    bankAccountId: '',
    isLogin: false,
    isEnterprise: false,
    partnerCode: '',
    payareaWalletId: '',
}

const initialState = {
    user: emptyUser,
    accessToken: '',
    language: languageSession,
    emailsStopped,
    alert: {
        text: '',
        type: '',
        isShow: false
    },
}

if (typeof window !== 'undefined') {
    const jsonUser = localStorage.getItem('user')
    initialState.user = jsonUser !== null ? JSON.parse(jsonUser) : emptyUser
    const language = localStorage.getItem('language')
    initialState.language = language !== null ? language : languageSession
    // const token = localStorage.getItem('track')
    // initialState.accessToken = token !== null ? token : ''
    const jsonEmails = localStorage.getItem('emailsStopped')
    initialState.emailsStopped = jsonEmails !== null ? JSON.parse(jsonEmails) : ''
}

const stateSlice = createSlice({
    name: 'appState',
    initialState,
    reducers: {
        loginUser: (state, action) => {
            state.user = action.payload
            const userSerialize = JSON.stringify(action.payload)
            localStorage.setItem('user', userSerialize)
        },
        setAccessToken: (state, action) => {
            state.accessToken = action.payload
            // localStorage.setItem('track', action.payload)
        },
        logoutUser: (state) => {
            state.user = emptyUser
            // localStorage.removeItem('track')
            localStorage.removeItem('user');
        },
        addUserEnterprise: (state) => {
            state.user.isEnterprise = true
            const userSerialize = JSON.stringify(state.user)
            localStorage.setItem('user', userSerialize)
        },
        updateMangopayInfo: (state, action) => {
            state.user.userMangoId = action.payload.userMangoId
            state.user.walletId = action.payload.walletId
            state.user.bankAccountId = action.payload.bankAccountId
        },
        toggleLanguage: (state) => {
            if (state.language === 'en') {
                localStorage.setItem('language', 'es')
                state.language = 'es'
            } else {
                state.language = 'en'
                localStorage.setItem('language', 'en')
            }
        },
        toggleEmailsStopped: (state,action) => {
            state.emailsStopped = action.payload
            localStorage.setItem('emailsStopped',JSON.stringify(state.emailsStopped))
        },
        showAlert: (state, action) => {
            state.alert = action.payload
            if (action.payload.type === 'success') {
                toast.success(action.payload.text, { autoClose: 1500})
            } else if (action.payload.type === 'warning') {
                const id = action.payload.id
                if (!toast.isActive(id)) {
                    toast.warn(action.payload.text, { autoClose: 3000, toastId: id })
                }
            } else if (action.payload.type === 'danger') {
                toast.error(action.payload.text, { autoClose: 3000 })
            }
        },
    },
})

export const selectUser = (state: any) => state.appState.user
export const selectToken = (state: any) => state.appState.token
export const selectLanguage = (state: any) => state.appState.language
export const selectAlert = (state: any) => state.appState.alert
export const selectEmailsStopped = (state : any) => state.appState.emailsStopped;

export const { loginUser } = stateSlice.actions
export const { setAccessToken } = stateSlice.actions
export const { logoutUser } = stateSlice.actions
export const { addUserEnterprise } = stateSlice.actions
export const { updateMangopayInfo } = stateSlice.actions
export const { toggleLanguage } = stateSlice.actions
export const { showAlert } = stateSlice.actions
export const { toggleEmailsStopped } = stateSlice.actions

export default stateSlice.reducer